import { documentToPlainTextString } from '@contentful/rich-text-plain-text-renderer';
import { Document } from '@contentful/rich-text-types';

/**
 * Converts Contentful rich text document to plain text string
 */
export const richTextToPlainText = (content?: Document): string => {
  if (!content) {
    return '';
  }

  try {
    return documentToPlainTextString(content).trim();
  } catch (error) {
    console.warn('Error converting rich text to plain text:', error);
    return '';
  }
};

/**
 * Sanitizes text for JSON-LD by escaping special characters
 */
export const sanitizeTextForJsonLd = (text: string): string => {
  return text
    .replace(/\\/g, '\\\\')
    .replace(/"/g, '\\"')
    .replace(/\n/g, ' ')
    .replace(/\r/g, ' ')
    .replace(/\t/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
};

/**
 * Generates a JSON-LD script tag for structured data
 */
export const createJsonLdScript = (data: object): string => {
  return JSON.stringify(data, null, 2);
};
